import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config"

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
    user: null
}
export const fetchUsers = createAsyncThunk(
    "fetchUsers",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.get(`/realestate/users/fetch-user-list?page=${body.page}&search=${body.search}`);

            return response.data;
        }
        catch (error) {
            return rejectWithValue(error?.response)
        }
    }
)

export const addUsers = createAsyncThunk(
    "addUsers",
    async (data, { rejectWithValue }) => {
        try {
            const response = await instance.post("/realestate/users/register-user", data);
            return response.data;
        }
        catch (error) {
            return rejectWithValue(error?.response)
        }
    }
)

export const UsersSlice = createSlice({
    name: 'UsersSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchUsers.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(fetchUsers.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload
            state.count = action.payload?.count


        })
        builder.addCase(fetchUsers.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });
        builder.addCase(addUsers.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(addUsers.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload

        })
        builder.addCase(addUsers.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });
    },

})

export default UsersSlice.reducer;